﻿import $ from "jquery";
import { Modal, Carousel } from "bootstrap";

$(() => {

    var currentPage = $("#currentPage").val();
    if (currentPage != "productIndex") return;    

    const $modal = $("#productPopup");
    const modal = Modal.getOrCreateInstance($modal[0], { backdrop: true, keyboard: true, focus: true });

    const $inner = $("#productPopupInner");
    const $dots = $("#productPopupDots");
    const $title = $("#productPopupTitle");

    const carouselEl = document.getElementById("productPopupCarousel") as HTMLElement;
    const carousel = Carousel.getOrCreateInstance(carouselEl, {
        interval: false,
        ride: false,
        wrap: true,
        touch: true, // mobile swipe
    });

    function render(images: string[]) {
        $inner.empty();
        $dots.empty();

        images.forEach((url, i) => {
            const active = i === 0 ? "active" : "";
            $inner.append(`
        <div class="carousel-item ${active}">
          <img class="zuba-product-modal-img" src="${url}" alt="">
        </div>
      `);

            $dots.append(`<button type="button" class="${i === 0 ? "is-active" : ""}" data-dot="${i}" aria-label="Slide ${i + 1}"></button>`);
        });

        // reset na prvý slide
        carousel.to(0);
    }

    function setActiveDot(index: number) {
        $dots.find("button").removeClass("is-active");
        $dots.find(`button[data-dot="${index}"]`).addClass("is-active");
    }

    // Open popup
    $(document).on("click", ".js-product-popup", function (e) {
        e.preventDefault();

        const title = String($(this).data("popup-title") ?? "");
        $title.text(title);

        const raw = $(this).attr("data-popup-images") ?? "[]";
        let images: string[] = [];
        try { images = JSON.parse(raw); } catch { images = []; }

        if (!images || images.length === 0) return;

        render(images);
        modal.show();
    });

    // Dots click
    $(document).on("click", "#productPopupDots button", function () {
        const i = parseInt(String($(this).data("dot")), 10);
        if (!isNaN(i)) {
            carousel.to(i);
        }
    });

    // Update dots on slide
    $(carouselEl).on("slid.bs.carousel", () => {
        const idx = $(carouselEl).find(".carousel-item.active").index();
        setActiveDot(idx);
    });

    // Desktop drag (pointer)
    let startX: number | null = null;
    let dragging = false;

    $(document).on("pointerdown", "#productPopupCarousel", function (ev) {
        startX = (ev as any).originalEvent?.clientX ?? null;
        dragging = true;
    });

    $(document).on("pointerup pointercancel", "#productPopupCarousel", () => {
        startX = null;
        dragging = false;
    });

    $(document).on("pointermove", "#productPopupCarousel", function (ev) {
        if (!dragging || startX === null) return;

        const x = (ev as any).originalEvent?.clientX ?? startX;
        const dx = x - startX;

        // threshold pre "swipe"
        if (Math.abs(dx) > 60) {
            dx < 0 ? carousel.next() : carousel.prev();
            startX = null;     // aby to neskákalo viac krát jedným ťahom
            dragging = false;
        }
    });

    // Reset pri zavretí
    $modal.on("hidden.bs.modal", () => {
        $inner.empty();
        $dots.empty();
        $title.text("");
    });
});
